import React, { useState } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { IconButton, Tooltip as MuiTooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useData } from '../context/DataContext';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend, ChartDataLabels);

const TransporteTercerizadoUtilizacionBar = ({ selectedIndustries = [], onBarClick = () => {} }) => {
  const [infoOpen, setInfoOpen] = useState(false);
  const { getTransportOutsourcing, dataReady } = useData();

  // Get data from Excel (3 years)
  const excelData = dataReady ? getTransportOutsourcing() : { labels: [], data2022: [], data2023: [], data2024: [] };

  // Use Excel data or fallback
  const allLabels = excelData.labels.length > 0
    ? excelData.labels
    : ['Servicios Logísticos', 'Retail', 'Alimentos', 'Construcción', 'Automotriz', 'Manufactura', 'Sector salud/ Farmacéuticas'];

  const allData2022 = excelData.data2022.length > 0 ? excelData.data2022 : [55, 66, 65, 12, 50, 81, 82];
  const allData2023 = excelData.data2023.length > 0 ? excelData.data2023 : [92, 79, 74, 71, 70, 68, 2];
  const allData2024 = excelData.data2024.length > 0 ? excelData.data2024 : [90, 75, 70, 65, 60, 55, 10];

  const labels = selectedIndustries.length > 0 ? selectedIndustries : allLabels;

  const getValuesForLabels = (allValues) => labels.map((label) => {
    const index = allLabels.indexOf(label);
    return index !== -1 ? allValues[index] : 0;
  });

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: '2023',
        data: getValuesForLabels(allData2022),
        backgroundColor: '#A2AEBB',
      },
      {
        label: '2024',
        data: getValuesForLabels(allData2023),
        backgroundColor: '#476A8E',
      },
      {
        label: '2025',
        data: getValuesForLabels(allData2024),
        backgroundColor: '#1F3D58',
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 40,
        bottom: 20,
        left: 10,
        right: 10,
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 15,
          padding: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.raw}%`,
        },
      },
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 9,
        },
        formatter: (value) => `${value}%`,
        anchor: 'end',
        align: 'top',
        offset: (context) => {
          // Stagger labels vertically to avoid overlap
          return context.datasetIndex === 0 ? 2 : context.datasetIndex === 1 ? 12 : 22;
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Industria',
          font: {
            size: 11,
            weight: 'bold',
          },
        },
      },
      y: {
        beginAtZero: true,
        max: 100,
        ticks: {
          stepSize: 10,
        },
        title: {
          display: true,
          text: 'Porcentaje de Transporte Tercerizado (%)',
          font: {
            size: 11,
            weight: 'bold',
          },
        },
      },
    },
  };

  const infoContent = {
    formulas: {
      transporteTercerizado: '(Número de operaciones de transporte tercerizadas / Total de operaciones de transporte) × 100',
    },
    description: 'Mide el nivel de uso de transporte subcontratado vs el total utilizado para entregas a cliente realizadas.',
  };

  return (
    <div style={{ maxWidth: '800px', height: '500px', margin: '0 auto', padding: '20px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <MuiTooltip title="Información de la gráfica">
          <IconButton onClick={() => setInfoOpen(true)}>
            <InfoIcon />
          </IconButton>
        </MuiTooltip>
      </Box>
      <Bar data={chartData} options={options} />
      <Dialog open={infoOpen} onClose={() => setInfoOpen(false)}>
        <DialogTitle>Información de la Gráfica</DialogTitle>
        <DialogContent>
          <p><strong>Fórmulas:</strong></p>
          <p>Transporte Tercerizado: {infoContent.formulas.transporteTercerizado}</p>
          <p><strong>Descripción:</strong> {infoContent.description}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default TransporteTercerizadoUtilizacionBar;
